export default __webpack_public_path__ + "assets/a1758db2503e65fb71d4e7953063e2ee.png";